import React from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import MainTemplate from '../../templates/MainTemplate'
import Filters from '../../containers/events/filters/Index'

import QuantityReceived from '../../containers/events/widgets/QuantityReceived'
import QuantityErrorsOffers from '../../containers/events/widgets/QuantityErrorsOffers'
import PersistOffers from '../../containers/events/widgets/PersistOffers'
import UniqueRegisterOffers from '../../containers/events/widgets/UniqueRegisterOffers'
import QuantityQueue from '../../containers/events/widgets/QuantityQueue'
import OffersSku from '../../containers/events/widgets/OffersSku'

import InsertOffersQueue from '../../containers/events/charts/InsertOffersQueue'
import StateEvent from '../../containers/events/charts/StateEvent'
import DailyOffersErrors from '../../containers/events/charts/DailyOffersErrors'
import DailyHttpCodes from '../../containers/events/charts/DailyHttpCodes'
import ValidationError from '../../containers/events/charts/ValidationError'
import EventTypes from '../../containers/events/charts/EventTypes'
import TopPharmaciesOffers from '../../containers/events/charts/TopPharmaciesOffers'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2)
    }
  })
)

const Index = (): JSX.Element => {
  const classes = useStyles()

  return (
    <MainTemplate>
      <Filters />

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={4} xs={12}>
          <QuantityReceived />
        </Grid>
        <Grid item sm={12} md={4} xs={12}>
          <QuantityErrorsOffers />
        </Grid>
        <Grid item sm={12} md={4} xs={12}>
          <QuantityQueue />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={4} xs={12}>
            <UniqueRegisterOffers />
        </Grid>
        <Grid item sm={12} md={4} xs={12}>
          <OffersSku />
        </Grid>
        <Grid item sm={12} md={4} xs={12}>
          <PersistOffers />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={12} xs={12}>
          <InsertOffersQueue />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={12} xs={12}>
            <StateEvent />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={12} xs={12}>
            <DailyHttpCodes />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={6} xs={12}>
            <DailyOffersErrors />
        </Grid>
        <Grid item sm={12} md={6} xs={12}>
            <ValidationError />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={6} md={12} xs={12}>
            <EventTypes />
        </Grid>
        <Grid item lg={6} md={12} xs={12}>
            <TopPharmaciesOffers />
        </Grid>
      </Grid>
    </MainTemplate>
  )
}

export default Index
